module.exports = __webpack_public_path__ + "04f07a9e8bb4dca94f1838083a983afc.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/faction_campaign_3-320.jpg
// module id = 298
// module chunks = 0